import Resource from '@/plugins/sdk/Resource'
import { STRING, UUID } from '@/plugins/sdk/fields'

export default class extends Resource {
  static name = 'dictionary_bgroup'
  static label = 'long'

  static get fields () {
    return {
      id: new UUID(),
      short: new STRING(),
      long: new STRING(),
      full_address: new STRING(),
      bill_address: new STRING(),
      phone: new STRING(),
      fax: new STRING(),
      email: new STRING(),
      abn: new STRING(),
      eft_bsb: new STRING(),
      eft_account: new STRING(),
      eft_name: new STRING(),
      logo: new STRING(),
      track_url: new STRING(),
      track_urlshort: new STRING(),
      track_sms: new STRING()
    }
  }
}
